import React from 'react';
import { useTranslation } from 'react-i18next';
import { InstruktorStyle } from './Instruktor.style';
import { Alert } from 'antd';

export interface Instructor {
  prowadzacyImie: string;
  prowadzacyNazwisko: string;
  prowadzacyPId: string;
  prowadzacyTytul: string;
}
export interface Props {
  value: {
    /** lista prowadzących */
    data: Instructor[];
  };
}
/**
 * Komponent mapujący realizatorów przedmiotu
 *
 */
const Instructor = (props: Props): React.ReactElement => {
  const { t } = useTranslation();

  return !props.value.data ? (
    <Alert message={t('NO_DATA')} type='error' />
  ) : (
    <InstruktorStyle>
      {props.value.data.map((instructor, index) => (
        <li key={`${instructor.prowadzacyPId}-${index}`}>
          {`${instructor.prowadzacyTytul} ${instructor.prowadzacyImie} ${instructor.prowadzacyNazwisko}`}
        </li>
      ))}
    </InstruktorStyle>
  );
};

export default Instructor;
